import React from "react";
import { Outlet } from "react-router-dom"; // <--- Important!
import SideBar from "./SideBar"; 

export default function AdminLayout() {
  return (
    <div className="flex bg-slate-950 min-h-screen w-full text-slate-200 font-sans selection:bg-indigo-500/30">
      
      {/* 1. The Sidebar (Fixed on left) */}
      <SideBar />

      {/* 2. The Main Content Area */}
      <div className="flex-1 flex flex-col h-screen overflow-hidden relative">
        
        {/* Optional: Cyber Grid Background Effect */}
        <div className="absolute inset-0 z-0 pointer-events-none">
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
        </div>

        {/* 3. The Outlet - This is where Dashboard/Attendance will appear */}
        <main className="flex-1 overflow-y-auto relative z-10">
          <Outlet /> 
        </main>
      </div>
    </div>
  );
}